// React import removed as it's not needed with modern JSX transform
import { createBrowserRouter, RouterProvider as ReactRouterProvider } from 'react-router-dom';
import { routes } from './routes.tsx';

/**
 * Router provider component that sets up the application router
 * This centralizes all routing configuration in one place
 */
export function RouterProvider() {
  // Create browser router with our routes configuration
  const router = createBrowserRouter(routes, {
    // Future flags for React Router v7 compatibility
    future: {
      // Using only supported flags
      v7_relativeSplatPath: true
    }
  });

  return <ReactRouterProvider router={router} />;
}
